<template>
  <div class="contact-us">
    <div class="form-wrapper">
      <ValidationObserver ref="formObserver" v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(onSubmit)">
          <h1 class="text-3xl lg:text-5xl font-bold mb-8">
            Contact BuyHive
          </h1>
          <h4 class="text-lg font-bold mb-8">
            <span class="text-red-600">*</span>All fields are required.
          </h4>
          <div class="md:flex">
            <div class="md:w-1/2 md:pr-5">
              <ValidationProvider
                v-slot="{ errors }"
                vid="f_name"
                rules="required"
              >
                <h4 class="text-md ml-1 font-medium"> First Name<span v-if="errors[0]" class="text-red-600">*</span></h4>
                <input
                  class="form-input"
                  type="text"
                  name="First Name"
                  v-model="formData.first_name"
                >
                <div class="input-error">{{ errors[0] ? 'Please enter your First Name' : '' }}</div>
              </ValidationProvider>
            </div>
            <div class="md:w-1/2 md:pl-5">
              <ValidationProvider
                v-slot="{ errors }"
                vid="l_name"
                rules="required"
              >
                <h4 class="text-md ml-1 font-medium"> Last Name<span v-if="errors[0]" class="text-red-600">*</span> </h4>
                <input
                  class="form-input"
                  type="text"
                  name="Last Name"
                  v-model="formData.last_name"
                >
                <div class="input-error">{{ errors[0] ? 'Please enter your Last Name' : ''}}</div>
              </ValidationProvider>
            </div>
          </div>
          <div class="md:flex">
            <div class="md:w-1/2 md:pr-5">
              <ValidationProvider
                v-slot="{ errors }"
                vid="email"
                rules="required|email"
              >
                <h4 class="text-md ml-1 font-medium"> E-mail Address<span v-if="errors[0]" class="text-red-600">*</span> </h4>
                <input
                  class="form-input"
                  type="text"
                  name="Email"
                  v-model="formData.email_address"
                >
                <div class="input-error">{{ errors[0] ? !formData.email_address.length ? 'Please enter your E-mail Address' : errors[0] :''}}</div>
              </ValidationProvider>
            </div>
            <div class="phone-field w-full md:w-1/2 md:pl-5" ref="phoneField">
              <ValidationProvider
                v-slot="{ errors }"
                rules="required|phoneNumber"
                :mode="mode"
                name="Phone"
              >
              <h4 class="text-md ml-1 font-medium"> Phone Number<span v-if="errors[0]" class="text-red-600">*</span> </h4>
                <VuePhoneNumberInput
                  v-model="formData.phone_number"
                  :default-country-code="'US'"
                  @update="getPhoneNumber"
                  @phone-number-focused="changePhoneValidationMode"
                  class="h-12"
                />
                <div class="input-error">{{ errors[0] ? checkPhoneErrorMessage(errors[0]) : ''}}</div>
              </ValidationProvider>
            </div>
          </div>
          <div class="md:flex">
            <div class="md:w-1/2 md:pr-5">
              <ValidationProvider
                v-slot="{ errors }"
                vid="country"
                rules="required"
                name="Country/Region"
              >
                <h4 class="text-md ml-1 font-medium"> Country/Region<span v-if="errors[0]" class="text-red-600">*</span> </h4>
                <country-select
                  v-model="formData.country"
                  :country="formData.country"
                  topCountry="US"
                  placeholder="Choose one"
                  class="form-input focus:text-opacity-100"
                  :class="{'text-dark text-opacity-50': !formData.country}"
                  ref="countrySelect"
                />
                <div class="input-error">{{ errors[0] ? 'Please choose your Country/Region' : '' }}</div>
              </ValidationProvider>
            </div>
            <div class="md:w-1/2 md:pl-5">
              <ValidationProvider
                v-slot="{ errors }"
                vid="subject"
                rules="required"
              >
                <h4 class="text-md ml-1 font-medium"> Enquiry Type<span v-if="errors[0]" class="text-red-600">*</span> </h4>
                <select
                  class="form-input focus:text-opacity-100"
                  v-model="formData.enquiry_type"
                  name="Enquiry Type"
                  :class="{'text-dark text-opacity-50': !formData.enquiry_type}"
                  placeholder="Choose one"
                >
                  <option value disabled>Choose one</option>
                  <option value="Buying">Buying</option>
                  <option value="Freelancer Sourcing">Expert Sourcing</option>
                  <option value="Financing">Financing</option>
                  <option value="Selling">Selling</option>
                  <option value="Other">Other</option>
                </select>
                <div class="input-error">{{ errors[0] ? 'Please choose your Enquiry Type' : '' }}</div>
              </ValidationProvider>
            </div>
          </div>
          <div>
            <ValidationProvider
              v-slot="{ errors }"
              vid="comments"
              rules="required"
            >
              <h4 class="text-md ml-1 font-medium"> Message<span v-if="errors[0]" class="text-red-600">*</span> </h4>
              <textarea
                class="border border-dark-b w-full p-3 h-48 rounded-lg"
                name="comments"
                v-model="formData.comments"
              />
              <div class="input-error">{{ errors[0] ? 'Please type your Message' : '' }}</div>
            </ValidationProvider>
          </div>
          <div class="pt-8 md:pt-12">
            <button class="new-app-btn bg-blue">Send a Message</button>
          </div>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
import VuePhoneNumberInput from 'vue-phone-number-input'

export default {
  name: 'ContactUs',
  components: { VuePhoneNumberInput },
  data() {
    return {
      formData: {
        first_name: '',
        last_name: '',
        email_address: '',
        phone_number:'',
        country: '',
        country_code: '',
        enquiry_type: '',
        comments: ''
      },
      mode: 'passive',
    }
  },
  mounted() {
    this.removePlaceholder()
    if(this.$route.query.enquiry_type == 'Expert Sourcing') {
      this.formData.enquiry_type = 'Freelancer Sourcing'
    } 
  
  },
  watch: {
    'formData.country'() {
      this.changePhoneValidationMode()
    }
  },
  methods: {
    ...mapActions ([
      'contactUs'
    ]),
    async onSubmit() {
      const response = await this.contactUs(this.formData)
      let msg = response.result ? 'We have received your request and we will get in touch within 24 to 48 hours.' : response.message
      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: msg,
        duration: 7000
      })
      if (response.result) {
        this.formData = {
          first_name: '',
          last_name: '',
          email_address: '',
          phone_number:'',
          country: '',
          country_code: '',
          enquiry_type: '',
          comments: ''
        }
        this.$refs.formObserver.reset()
      }
    },
    getPhoneNumber(num) {
      this.formData.country_code = num.countryCallingCode
    },
    changePhoneValidationMode() {
      this.mode = 'passive'
      this.$nextTick(()=> {
        this.mode = 'aggressive'
      })
    },
    removePlaceholder(){
      const phoneInput = this.$refs.phoneField.querySelectorAll('input')
      phoneInput[1].removeAttribute("placeholder");
    },
    checkPhoneErrorMessage(message) {
      return message === 'Phone is not valid.' ? 'Please enter your Phone Number' : message
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '@/assets/styles/variables.scss';
  .contact-us {
    @apply mx-auto max-w-max pb-12;
    @screen md { @apply px-0 w-95 pt-12; }
    .form-wrapper {
      @apply bg-smoke-100 py-8 px-5 ;
      @screen md { @apply rounded-lg py-12 px-30; }
      max-width: 920px;
      .phone-field {
        /deep/::placeholder {
          color: $gray_500 !important;
        }
        /deep/input.input-tel__input,
        /deep/input.country-selector__input {
          border-radius: 0.5rem !important;
          border-color: $dark-b !important;
          height: 48px !important;
          &:focus { box-shadow: none !important;}
        }
        /deep/label { color: $gray_500 !important; }
        /deep/.flex-1 { margin-left: 0.5rem; }
      }
      .input-error{
        text-align: right;
        padding-right: 4px;
      }
    }
  }
</style>